import { useEffect, useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCandleRadar, fetchEarlyRunners } from "./api";

const SEEN_KEY = "alphaapeing_candle_seen";

export const getCandleSeen = () => {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]")); } catch { return new Set(); }
};

export const markCandlesSeen = (mints) => {
  localStorage.setItem(SEEN_KEY, JSON.stringify(mints || []));
  window.dispatchEvent(new Event("candle-seen-updated"));
};

export const useCandleAlerts = () => {
  const q = useQuery({ queryKey: ["candleRadar"], queryFn: fetchCandleRadar, refetchInterval: 45000 });
  const eq = useQuery({ queryKey: ["earlyRunners"], queryFn: fetchEarlyRunners, refetchInterval: 40000 });
  const mints = useMemo(() => {
    const out = [];
    for (const r of q.data?.launch || []) if (r.mint) out.push(r.mint);
    for (const r of q.data?.carry || []) if (r.mint) out.push(r.mint);
    for (const r of eq.data?.runners || []) if (r.mint) out.push(r.mint);
    return out;
  }, [q.data, eq.data]);

  const [seen, setSeen] = useState(getCandleSeen);
  useEffect(() => {
    const h = () => setSeen(getCandleSeen());
    window.addEventListener("candle-seen-updated", h);
    return () => window.removeEventListener("candle-seen-updated", h);
  }, []);

  const newCount = mints.filter((m) => !seen.has(m)).length;
  return { newCount, mints };
};
